<template>
  <chat-window
    :current-user-id="currentUserId"
    :rooms="rooms"
    :messages="messages"
    :rooms-loaded="roomsLoaded"
    :messages-loaded="messagesLoaded"
    :text-messages="textMessages"
    :message-actions="messageActions"
    :height="height"
    :accepted-files="acceptedFiles"
    :show-add-room="false"
    :show-new-messages-divider="false"
    :media-preview-enabled="true"
    :show-footer="showFooter"
    :menu-actions="menuActions"
    @fetch-messages="getMessages"
    @send-message="onSendMessage"
    @edit-message="editMessage"
    @delete-message="deleteMessage"
    @open-file="openFile"
    @send-message-reaction="sendMessageReaction"
    @menu-action-handler="onMenuAction"
  />
</template>

<script>
import ChatWindow, {StringNumber} from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
export default {
  components: {
    ChatWindow
  },
  data () {
    return {
      textMessages:{
        ROOMS_EMPTY: 'У вас нет активных диалогов',
        ROOM_EMPTY: 'В этом чате ещё нет сообщений',
        NEW_MESSAGES: 'Новые сообщения',
        MESSAGE_DELETED: 'Сообщение удалено',
        MESSAGES_EMPTY: 'Нет сообщений',
        CONVERSATION_STARTED: 'Обсуждение начато:',
        TYPE_MESSAGE: 'Напишите сообщение',
        SEARCH: 'Искать',
        IS_ONLINE: 'online',
        LAST_SEEN: 'был в сети',
        IS_TYPING: 'набирается..',
        CANCEL_SELECT_MESSAGE: 'Отмена',
      },
      messageActions: [
      {
        name: 'replyMessage',
        title: 'Ответить'
      },
      // {
      //   name: 'forwardMessages',
      //   title: 'Переслать'
      // },
      // {
      //   name: 'selectMessages',
      //   title: 'Выбрать'
      // },
      // {
      //   name: 'pinMessages',
      //   title: 'Закрепить'
      // },
      {
        name: 'editMessage',
        title: 'Редактировать',
        onlyMe: true
      },
      {
        name: 'deleteMessage',
        title: 'Удалить',
        onlyMe: true
      }
    ],
    // messageSelectionActions: [
    //   {
    //     name: 'forwardMessages',
    //     title: 'Переслать'
    //   },
    //   {
    //     name: 'deleteMessage',
    //     title: 'Удалить',
    //     onlyMe: true // TODO: пофиксить, чтоб показывало кнопку только для своих сообщений
    //   }
    // ],
    menuActions: [
    //   {
    //     name: 'inviteUser',
    //     title: 'Пригласить юзера'
    //   },
    //   {
    //     name: 'removeUser',
    //     title: 'Удалить юзера'
    //   },
    //   {
    //     name: 'deleteRoom',
    //     title: 'Удалить чат'
    //   }
     {
        name: 'logout',
        title: 'Выход'
      }
    ],
    //   templatesText: [
    //   {
    //     tag: 'help',
    //     text: 'Это помощь - список всех функций чата'
    //   },
    //   // {
    //   //   tag: 'action',
    //   //   text: 'This is the action'
    //   // }
    // ],
    height: '100vh',
    acceptedFiles: `image/avif, image/webp, image/apng, image/svg+xml, image/*, image/gif, image/jpeg, image/png,
                     application/pdf,
                     audio/mpeg, audio/mp3, audio/m4a, audio/wav,
                     video/x-m4v, video/mp4, video/m4v, video/mpg, video/mov, video/avi, video/swf`
    }
  },
  computed: {
    ...mapState('chat', [
        'messages',
        'rooms',
        'roomsLoaded',
        'messagesLoaded'
    ]),
    ...mapState('auth', [
      'user'
    ]),
    ...mapGetters('auth',{
      currentUserId: 'getUserId'
    },),
    ...mapGetters('chat', {
      showFooter: 'isReadOnly'
    })
  },
  methods: {
    ...mapActions('auth',[
       'logout'
    ]),
    ...mapActions('chat', [
        'getRooms',
        'getMessages',
        'sendMessage',
        'editMessage',
        'deleteMessage',
        'sendMessageReaction',

    ]),
    onSendMessage({ roomId, content, files, replyMessage, usersTag }) {
      let dt = new Date();
      let date = dt.toLocaleDateString("ru");
      let time =  dt.toLocaleTimeString("ru",{hour: '2-digit', minute:'2-digit'} );
      let message_files = []
      if (files) {
        message_files = this.$store.getters['chat/formattedFiles'](files)
      }
      let message = {
        _id: Math.ceil(Math.random()*-10000),
        uri: dt.getTime(), // Задаём уникальный индификатор, чтобы потом распознать это сообщение
        content: content,
        files: message_files,
        replyMessage: replyMessage,
        usersTag: usersTag,
        senderId: this.currentUserId,
        username: this.user.username,
        avatar: this.user.avatar,
        date: date,
        timestamp: time,
        saved: false,
        distributed: false,
        seen: false,
        reactions: {}
      };
      this.sendMessage({roomId, message});
    },
    openFile({ file }) {
			window.open(file.file.url, '_blank')
		},
    onMenuAction({ roomId, action }) {
      if (action.name === 'logout') {
        this.logout();
      }
    }
  },
  mounted() {
    this.getRooms();
  }
}
</script>

<style>
.vac-message-actions-wrapper .vac-message-options svg{
  width: 17px;
  height: 17px;
  margin: 0;
  padding: 0;
}
.vac-video-container video{
  width: 100%;
  height: 100%;
}
</style>
